import type { FolderApi } from 'tweakpane';
import { Pane } from 'tweakpane';
import { Signal } from 'typed-signals';
import type { BaseCondition, OfferSystemConfig } from '../offerSystemTypes';
import { bindingOptionsFromArray } from './utils/bindingOptionsFromArray';
import { saveFile } from '../../../utils/FileIO';

export class OfferSystemEditorMenu<S, C extends BaseCondition, GD> {
  public readonly onRefreshOffer = new Signal<(location: string, trigger: string | null) => void>();

  public readonly onSetVisibilityOfAlwaysActive = new Signal<(visible: boolean) => void>();

  public readonly onPurchaseMade = new Signal<(offerId: string) => void>();

  public readonly element: HTMLDivElement = document.createElement('div');

  private readonly pane = new Pane();

  private readonly purchaseFolder: FolderApi;

  constructor(private readonly config: OfferSystemConfig<S, C, GD>) {
    Object.assign(this.element.style, {
      position: 'fixed',
      top: '0',
      right: '400px',
    });
    document.body.appendChild(this.element);

    this.createMenu();

    this.purchaseFolder = this.pane.addFolder({ title: 'Make purchase' });
  }

  private createMenu(): void {
    this.element.appendChild(this.pane.element);

    const temp = {
      location: '*',
      trigger: '*',
      showAlwaysActive: true,
    };

    const folder = this.pane.addFolder({ title: 'Offers', expanded: true });

    folder.addButton({ title: 'Export json' }).on('click', () => {
      saveFile(JSON.stringify(this.config.offers, null, ''), `offers_${new Date().toUTCString()}.json`);
    });

    folder.addBinding(temp, 'showAlwaysActive', { label: 'Show always active' }).on('change', (event) => {
      this.onSetVisibilityOfAlwaysActive.emit(event.value);
    });

    folder.addBinding(temp, 'location', {
      options: bindingOptionsFromArray(['*', ...this.config.locations]),
    });

    folder.addBinding(temp, 'trigger', {
      options: bindingOptionsFromArray(['*', ...this.config.triggers]),
    });

    folder.addButton({ title: 'Update offers state' }).on('click', () => {
      this.onRefreshOffer.emit(temp.location, temp.trigger === '*' ? null : temp.trigger);
    });
  }

  public updatePurchaseOffers(offerIds: string[]): void {
    this.purchaseFolder.children.slice().forEach((child) => {
      child.dispose();
    });

    offerIds.forEach((offerId) => {
      this.purchaseFolder.addButton({ title: offerId }).on('click', () => {
        this.onPurchaseMade.emit(offerId);
      });
    });
  }
}
